const loadingMessages = [
  "GoodPlanningIsHalfTheWayToSuccess",
  "EveryBigAchievementStartsWithASmallStep",
  "FocusOnProgressNotPerfection",
  "YourGoalsAreCloserThanYouThink",
  "ConsistencyIsTheKeyToSuccess",
  "DreamBigPlanSmartActNow",
  "TurningYourGoalsIntoReality",
  "SuccessIsAJourneyNotADestination",
  "SmallDailyImprovementsLeadToBigResults",
  "StayFocusedStayMotivated",
  "OrganizePrioritizeAchieve",
  "MakeEveryDayCount",
  "TheBestTimeToStartIsNow",
  "BelieveInYourselfAndAllThatYouAre",
  "HardWorkBeatsTalentWhenTalentFails",
  "YourOnlyLimitIsYourMind",
  "TurnYourWoundsIntoWisdom",
  "TheFutureBelongsToThoseWhoBelieve",
  "DoWhatYouCanWithWhatYouHave",
  "ProgressOverPerfection",
  "OneTaskAtATime",
  "KeepMovingForward",
  "ActionIsTheKeyToSuccess",
  "StartWhereYouAreUseWhatYouHave",
  "NeverStopLearning",
  "BeBetterThanYesterday",
  "DoneIsBetterThanPerfect",
  "YourJourneyStartsToday",
  "CreateYourOwnOpportunities",
  "MomentumBeatsMotivation",
  "AGoalWithoutAPlanIsJustAWish",
  "BreakBigGoalsIntoSmallSteps",
  "PlanYourWorkAndWorkYourPlan",
  "StayPatientTrustTheProcess",
  "EveryMasterWasOnceABeginner",
];

export default loadingMessages;
